import { render, staticRenderFns } from "./RHorRODialog.vue?vue&type=template&id=668c5ee7"
import script from "./RHorRODialog.vue?vue&type=script&lang=ts"
export * from "./RHorRODialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports